import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { cpfMask } from "utils/cpf";

interface IFilters {
  nomeCpf: string,
  plano: 'Todos' | 'PlanoA' | 'PlanoB',
  cargo: 'Todos' | 'Auxiliar' | 'Gerente'
  parentesco: 'Todos' | 'Titular' | 'Dependente',
}

const dataProps = [
  {
    movimentacao: "Demissão",
    cpf: '12345678910',
    cpfDependente: '09129823746',
    nome: "Murilo",
    parentesco: "Titular", //Titular/Dependente
    plano: "PlanoA",
    cargo: "Auxiliar",
    dataAdmissao: '15/02/2025',
    dataDemissao: '16/02/2025',
    municipio: 'Curitiba'
  },
];

interface IData {
  movimentacao: string; //"Inclusão" | "Demissão" | "Transferência" | "Alteração";
  cpf: string;
  cpfDependente: string;
  nome: string;
  parentesco: string; //"Titular" | "Dependente";
  plano: string;
  cargo: string;
  dataAdmissao: string;
  dataDemissao: string;
  municipio: string;
  registrationNumber: string;
}

const ContractViewProcessTable = ({ data: xxAllDataz }: { data: IData[] }) => {
  const xxAllFilters: IFilters = {
    nomeCpf: '',
    plano: 'Todos',
    cargo: 'Todos',
    parentesco: 'Todos',
  }
  const [xxCurrentData, setXxCurrentData] = useState(xxAllDataz);
  const [xxCurrentFilters, setXxCurrentFilters] = useState(xxAllFilters);

  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = useState<string>('nome');

  const planoOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.plano))];
  const parentescoOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.parentesco))];
  const cargoOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.cargo))];

  function handleFilters(filters: IFilters) {
    setXxCurrentFilters({ ...filters });
  }

  const handleSort = (property: string) => {
    const isAsc = order === 'asc'; //orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect(() => {
    const filteredData = xxAllDataz.filter(data => {
      const shouldDisplayName = data.nome.toLocaleLowerCase().includes(xxCurrentFilters.nomeCpf.toLocaleLowerCase()) || data.cpf.includes(xxCurrentFilters.nomeCpf);
      const shouldDisplayPlano = xxCurrentFilters.plano === 'Todos' || xxCurrentFilters.plano === data.plano;
      const shouldDisplayCargo = xxCurrentFilters.cargo === 'Todos' || xxCurrentFilters.cargo === data.cargo;
      const shouldDisplayParentesco = xxCurrentFilters.parentesco === 'Todos' || xxCurrentFilters.parentesco === data.parentesco;

      return shouldDisplayName && shouldDisplayPlano && shouldDisplayCargo && shouldDisplayParentesco;
    });
    const sortedData = filteredData.sort((a, b) => {
      if (orderBy === 'nome') {
        const aValue = a.nome.toLowerCase();
        const bValue = b.nome.toLowerCase();
        if (aValue < bValue) return order === 'asc' ? -1 : 1;
        if (aValue > bValue) return order === 'asc' ? 1 : -1;
        return 0;
      }
      if (a.plano < b.plano) return order === 'asc' ? -1 : 1;
      if (a.plano > b.plano) return order === 'asc' ? 1 : -1;
      return 0;
    });
    setXxCurrentData([ ...sortedData ]);
  }, [xxCurrentFilters, order, orderBy]);

  return (
    <>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <TextField
          fullWidth
          label='Nome beneficiário ou CPF'
          placeholder='Digite para pesquisar'
          variant='outlined'
          value={xxCurrentFilters.nomeCpf}
          onChange={(e) => handleFilters({ ...xxCurrentFilters, nomeCpf: e.target.value  })}
          InputProps={{ 
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon color='action' style={{ width: '24px', aspectRatio: '1' }}/>
              </InputAdornment>
            )
          }}
        />
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', marginBottom: '24px' }}>
          <Typography color='gray' variant='body2'>Filtrar por</Typography>
          <FormControl style={{ width: '165px' }}>
            <InputLabel id="plano">Plano</InputLabel>
            <Select
              labelId="plano"
              label="Plano"
              value={xxCurrentFilters.plano}
              defaultValue={'Todos'}
              //@ts-ignore
              onChange={(e) => handleFilters({ ...xxCurrentFilters, plano: e.target.value  })}
              style={{ height: '40px' }}
            >
              {planoOptions.map(option => (
                <MenuItem value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl style={{ width: '165px' }}>
            <InputLabel id="parentesco">Parentesco</InputLabel>
            <Select
              labelId="parentesco"
              label="Parentesco"
              value={xxCurrentFilters.parentesco}
              defaultValue={'Todos'}
              //@ts-ignore
              onChange={(e) => handleFilters({ ...xxCurrentFilters, parentesco: e.target.value  })}
              style={{ height: '40px' }}
            >
              {parentescoOptions.map(option => (
                <MenuItem value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl style={{ width: '165px' }}>
            <InputLabel id="cargo">Cargo</InputLabel>
            <Select
              labelId="cargo"
              label="Cargo"
              value={xxCurrentFilters.cargo}
              defaultValue={'Todos'}
              //@ts-ignore
              onChange={(e) => handleFilters({ ...xxCurrentFilters, cargo: e.target.value  })}
              style={{ height: '40px' }}
            >
              {cargoOptions.map(option => (
                <MenuItem value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button onClick={() => handleFilters({ nomeCpf: '', cargo: 'Todos', parentesco: 'Todos', plano: 'Todos' })}>Limpar filtro</Button>
        </div>
      </div>
      <TableContainer
        sx={{
          "& .MuiTableCell-root": {
            background: "#FFFFFF !important",
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {/* <TableCell>Movimentação</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'movimentacao'}
                    direction={orderBy === 'movimentacao' ? order : 'asc'}
                    onClick={() => handleSort('movimentacao')}
                  >
                  Movimentação
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>CPF</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'cpf'}
                    direction={orderBy === 'cpf' ? order : 'asc'}
                    onClick={() => handleSort('cpf')}
                  >
                  CPF
                </TableSortLabel>
              </TableCell>
              <TableCell>Número de matrícula</TableCell>
              {/* <TableCell>CPF Dependente</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'cpfDependente'}
                    direction={orderBy === 'cpfDependente' ? order : 'asc'}
                    onClick={() => handleSort('cpfDependente')}
                  >
                  CPF Dependente
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'nome'}
                    direction={orderBy === 'nome' ? order : 'asc'}
                    onClick={() => handleSort('nome')}
                  >
                  Nome
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>Parentesco</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'parentesco'}
                    direction={orderBy === 'parentesco' ? order : 'asc'}
                    onClick={() => handleSort('parentesco')}
                  >
                  Parentesco
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'plano'}
                    direction={orderBy === 'plano' ? order : 'asc'}
                    onClick={() => handleSort('plano')}
                  >
                  Plano
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>Cargo</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'cargo'}
                    direction={orderBy === 'cargo' ? order : 'asc'}
                    onClick={() => handleSort('cargo')}
                  >
                  Cargo
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>Data Admissão</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'dataAdmissao'}
                    direction={orderBy === 'dataAdmissao' ? order : 'asc'}
                    onClick={() => handleSort('dataAdmissao')}
                  >
                  Data Admissão
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>Data Demissão</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'dataDemissao'}
                    direction={orderBy === 'dataDemissao' ? order : 'asc'}
                    onClick={() => handleSort('dataDemissao')}
                  >
                  Data Demissão
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>Municipio</TableCell> */}
              <TableCell>
                <TableSortLabel
                    active={orderBy === 'municipio'}
                    direction={orderBy === 'municipio' ? order : 'asc'}
                    onClick={() => handleSort('municipio')}
                  >
                  Municipio
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {xxCurrentData.map((row) => (
              <TableRow>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.movimentacao}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {Number(row.cpf) ? cpfMask(row.cpf) : row.cpf}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.registrationNumber}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {Number(row.cpfDependente) ? cpfMask(row.cpfDependente) : row.cpfDependente}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.nome}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.parentesco}
                  </div>  
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.plano}
                  </div>  
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.cargo}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.dataAdmissao}
                  </div>  
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.dataDemissao}
                  </div>  
                </TableCell>
                <TableCell>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.municipio}
                  </div>  
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ContractViewProcessTable;
